// Resume Preferences ********************************************************************************
// pathname: /v1/resume/preferences
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';
import { ApiUserJobTypePreferencesOk } from 'src/types/v1-api-types';

interface SwrResumePreferencesProps {
  locale?: Locale;
  shouldFetch?: boolean;
}

/**
 * SWR: fetch the user's job type preferences (salary, full/part-time,
 * remote, recruitment projects, resumeAddress).
 */
export const useSwrResumePreferences = (props: SwrResumePreferencesProps) => {
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiUserJobTypePreferencesOk>({
    url: '/v1/resume/preferences',
    shouldFetch,
    locale,
    apiOptions: {
      dedupingInterval: 60 * 1000,
      revalidateOnFocus: false,
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
